// src/pages/AdminProdutos/ProdutoForm.js
import React, { useState, useEffect } from 'react';
import './ProdutoForm.css';

const ProdutoForm = ({ onSubmit, produtoInicial, onCancelar }) => {
  const [nome, setNome] = useState('');
  const [opcoes, setOpcoes] = useState([]); // Array de objetos { tamanho, preco, adicionaisDisponiveis }
  const [ativoPDV, setAtivoPDV] = useState(true); // Novo campo para o PDV

  useEffect(() => {
    if (produtoInicial) {
      setNome(produtoInicial.nome);
      setOpcoes(produtoInicial.opcoes || []);
      setAtivoPDV(produtoInicial.ativoPDV !== undefined ? produtoInicial.ativoPDV : true);
    } else {
      // Reseta o formulário se não houver produto inicial
      setNome('');
      setOpcoes([]);
      setAtivoPDV(true);
    }
  }, [produtoInicial]);

  const handleAddOpcao = () => {
    setOpcoes([...opcoes, { tamanho: '', preco: 0, adicionaisDisponiveis: [] }]);
  };

  const handleRemoveOpcao = (index) => {
    const newOpcoes = opcoes.filter((_, i) => i !== index);
    setOpcoes(newOpcoes);
  };

  const handleOpcaoChange = (index, field, value) => {
    const newOpcoes = [...opcoes];
    if (field === 'preco') {
      newOpcoes[index][field] = parseFloat(value) || 0; // Converte para número
    } else {
      newOpcoes[index][field] = value;
    }
    setOpcoes(newOpcoes);
  };

  const handleAddAdicional = (opcaoIndex) => {
    const newOpcoes = [...opcoes];
    newOpcoes[opcaoIndex].adicionaisDisponiveis.push({ id: '', nome: '', preco: 0 });
    setOpcoes(newOpcoes);
  };

  const handleRemoveAdicional = (opcaoIndex, adicionalIndex) => {
    const newOpcoes = [...opcoes];
    newOpcoes[opcaoIndex].adicionaisDisponiveis = newOpcoes[opcaoIndex].adicionaisDisponiveis.filter((_, i) => i !== adicionalIndex);
    setOpcoes(newOpcoes);
  };

  const handleAdicionalChange = (opcaoIndex, adicionalIndex, field, value) => {
    const newOpcoes = [...opcoes];
    if (field === 'preco') {
      newOpcoes[opcaoIndex].adicionaisDisponiveis[adicionalIndex][field] = parseFloat(value) || 0;
    } else if (field === 'id') {
      // Para o ID do adicional, geralmente é o nome em minúsculas e sem espaços
      newOpcoes[opcaoIndex].adicionaisDisponiveis[adicionalIndex][field] = value.toLowerCase().replace(/\s/g, '-');
    }
    else {
      newOpcoes[opcaoIndex].adicionaisDisponiveis[adicionalIndex][field] = value;
    }
    setOpcoes(newOpcoes);
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    const produtoData = { nome, opcoes, ativoPDV };
    if (produtoInicial) {
      onSubmit(produtoInicial.id, produtoData); // Para edição
    } else {
      onSubmit(produtoData); // Para adição
    }
  };

  return (
    <form onSubmit={handleSubmit} className="produto-form">
      <div className="form-group">
        <label>Nome do Produto:</label>
        <input
          type="text"
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          required
        />
      </div>

      <div className="form-group">
        <label>Ativo no PDV:</label>
        <input
          type="checkbox"
          checked={ativoPDV}
          onChange={(e) => setAtivoPDV(e.target.checked)}
        />
      </div>

      <h3>Opções de Tamanho/Preço:</h3>
      {opcoes.map((opcao, opcaoIndex) => (
        <div key={opcaoIndex} className="opcao-item">
          <div className="opcao-details">
            <label>Tamanho:</label>
            <input
              type="text"
              value={opcao.tamanho}
              onChange={(e) => handleOpcaoChange(opcaoIndex, 'tamanho', e.target.value)}
              required
              placeholder="Ex: P, G, M"
            />
            <label>Preço:</label>
            <input
              type="number"
              step="0.01"
              value={opcao.preco.toFixed(2)}
              onChange={(e) => handleOpcaoChange(opcaoIndex, 'preco', e.target.value)}
              required
            />
            <button type="button" onClick={() => handleRemoveOpcao(opcaoIndex)} className="remove-btn">
              Remover Opção
            </button>
          </div>

          <h4>Adicionais para esta Opção:</h4>
          {opcao.adicionaisDisponiveis.map((adicional, adicionalIndex) => (
            <div key={adicionalIndex} className="adicional-item">
              <label>ID Adicional:</label>
              <input
                type="text"
                value={adicional.id}
                onChange={(e) => handleAdicionalChange(opcaoIndex, adicionalIndex, 'id', e.target.value)}
                placeholder="Ex: cheddar-bacon"
                required
              />
              <label>Nome Adicional:</label>
              <input
                type="text"
                value={adicional.nome}
                onChange={(e) => handleAdicionalChange(opcaoIndex, adicionalIndex, 'nome', e.target.value)}
                placeholder="Ex: Cheddar e Bacon"
                required
              />
              <label>Preço Adicional:</label>
              <input
                type="number"
                step="0.01"
                value={adicional.preco.toFixed(2)}
                onChange={(e) => handleAdicionalChange(opcaoIndex, adicionalIndex, 'preco', e.target.value)}
                required
              />
              <button type="button" onClick={() => handleRemoveAdicional(opcaoIndex, adicionalIndex)} className="remove-btn">
                Remover Adicional
              </button>
            </div>
          ))}
          <button type="button" onClick={() => handleAddAdicional(opcaoIndex)} className="add-nested-btn">
            + Adicionar Adicional
          </button>
        </div>
      ))}
      <button type="button" onClick={handleAddOpcao} className="add-main-btn">
        + Adicionar Opção de Tamanho/Preço
      </button>

      <div className="form-actions">
        <button type="submit" className="save-btn">{produtoInicial ? 'Salvar Edição' : 'Adicionar Produto'}</button>
        {produtoInicial && <button type="button" onClick={onCancelar} className="cancel-btn">Cancelar</button>}
      </div>
    </form>
  );
};

export default ProdutoForm;